<template>
  <div class="container-fluid">
    <div class="row">
      <div class="d-none d-md-block col-3 pt-5 register-banner">
        <div class="text-md-center mt-5 text-white" style="font-size: 24px">
          Comienza a <b>practicar</b> tus <b>habilidades</b> en
          <b>matemáticas</b> ahora
        </div>
      </div>

      <div class="col p-4">
        <p class="text-black-50 text-right">
          ¿Ya tienes cuenta?
          <router-link to="/v2/auth/login" class="text-dark">Ingresa</router-link>
        </p>

        <div
          v-if="!postRecover"
          class="text-center py-4"
          style="max-width: 376px; margin: auto"
        >
          <MobiusLogo to="/home" />

          <h1 class="text-dark font-h3 mt-5">Recupera tu contraseña</h1>

          <span class="d-block text-center mt-4 mb-3 text-black-50">
            Ingresa tu correo para continuar
          </span>

          <!-- Recover Password form -->
          <form>
            <div class="form-group">
              <label for="email">Correo</label>
              <input type="text" v-model="recoverInfo.email" id="email" class="form-control"/>
              <small v-if="formErrorMessage.email" class="error-hint">
                {{ formErrorMessage.email }}
              </small>
            </div>
            <button class="btn btn-primary w-100" @click.prevent="recoverPassword()">
              Recuperar Contraseña
            </button>
          </form>
          <!-- End Login form -->
        </div>

        <div
          v-else
          class="m-auto mt-4 p-4 text-center"
          style="max-width: 500px"
        >
          <IconifyIcon :icon="icons.bxEnvelope" height="32" />
          <h2 class="h4 mt-4">
            Hemos enviado un correo de para recuperar la contraseña al email que usaste para
            registrarte
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IconifyIcon from "@iconify/vue";
import bxEnvelope from "@iconify/icons-bx/bx-envelope";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "RecoverPassword",
  components: { IconifyIcon, MobiusLogo },
  data() {
    return {
      recoverInfo: {
        email: ""
      },
      formErrorMessage: {
        email: null,
      },
      postRecover: false,
      icons: {
        bxEnvelope,
      },
    };
  },
  methods: {
    recoverPassword() {
      if (this.validateRecoverPasswordInfo()) {
        let loader = this.$loading.show({});
        axios
          .post(
            `${import.meta.env.VITE_API_BASE_URL}/auth/recover-password`, this.recoverInfo
          )
          .then((response) => {
            if (response.status === 200) {
              this.postRecover = true;
            }
            loader.hide();
          })
          .catch((error) => {
            const apiMessage = error.response?.data?.message;
            this.$toasted.error(
              apiMessage || "El correo que ingresaste no existe en nuestra base de datos.",
              { position: "top-center", duration: 8000 }
            );
            loader.hide();
          });
      }
    },
    validateRecoverPasswordInfo() {
      let errorCount = 0;

      if (!this.recoverInfo.email) {
        this.formErrorMessage.email = "Este campo es requerido";
        errorCount++;
      } else {
        this.formErrorMessage.email = null;
      }
      return errorCount === 0;
    },

    goToLogin() {
      // Redirect to login
      this.$router.push("/v2/auth/login");
    },
    mounted() {

    },
  },
};
</script>

<style scoped>
.register-banner {
  background-image: url("../assets/images/register-banner.jpg");
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  max-width: 430px;
}
</style>
